import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge doesn't know about our custom typography scale (heading-lg,
// body-sm, etc.) — without this, it classifies all `text-*` classes into
// one conflict group and silently drops the "unrecognized" one when merged
// with a text-color class like text-textHighEmphasis.
export const TYPOGRAPHY_FONT_SIZE_VARIANTS = [
  "display-sm",
  "display-md",
  "display-lg",
  "display-xl",
  "heading-xs",
  "heading-sm",
  "heading-md",
  "heading-lg",
  "heading-xl",
  "heading-xxl",
  "body-xs",
  "body-sm",
  "body-md",
  "body-lg",
  "label-xs",
  "label-sm",
  "label-md",
  "label-lg",
  "eyebrow-xs",
  "eyebrow-sm",
  "eyebrow-md",
  "eyebrow-lg",
] as const;

export type TypographyVariant = (typeof TYPOGRAPHY_FONT_SIZE_VARIANTS)[number];

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: TYPOGRAPHY_FONT_SIZE_VARIANTS }],
    },
  },
});
